<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: "ViewBypass",
};
</script>
